export const SET_ACH_REF = "SET_ACH_REF";
export const SET_STRIPE_REF = "SET_STRIPE_REF";
export const UPDATE_CURRENCY = "UPDATE_CURRENCY";
export const SET_GOOGLE_APPLE_ID = "SET_GOOGLE_APPLE_ID";
export const SET_GOOGLE_APPLE_REF = "SET_GOOGLE_APPLE_REF";
export const RESET_PAYMENT_METHOD = "RESET_PAYMENT_METHOD";
export const UPDATE_CHECKOUT_STATE = "UPDATE_CHECKOUT_STATE";
export const UPDATE_DONATION_MESSAGE = "UPDATE_DONATION_MESSAGE";
export const INITIATE_DONATION_SUBMISSION = "INITIATE_DONATION_SUBMISSION";
export const RESET_COUNTRY_DEPENDENT_VALUES = "RESET_COUNTRY_DEPENDENT_VALUES";
export const UPDATE_STATE_BASED_ON_LOCATION = "UPDATE_STATE_BASED_ON_LOCATION";
export const UPDATE_CHECKOUT_CONTACT_DETAILS = "UPDATE_CHECKOUT_CONTACT_DETAILS";
export const UPDATE_DONATION_PROCESSING_STATE = "UPDATE_DONATION_PROCESSING_STATE";
export const UPDATE_STATE_BASED_ON_PAGE_DETAILS = "UPDATE_STATE_BASED_ON_PAGE_DETAILS";